import React from 'react';
import { RaisedButton, CircularProgress } from 'material-ui';
import { useSubmit } from './hooks/useSubmit';

export function SubmitButton({ url, body, children, t, ...props }) {
  const { handleSubmit, loading, error, data } = useSubmit(url, body);
  return (
    <div style={{ padding: '1em 2em' }}>
      <RaisedButton
        disabled={loading}
        {...props}
        icon={loading && <CircularProgress size={10} thickness={1} />}
        onClick={handleSubmit}
      >
        {children}
      </RaisedButton>
      {data && <p style={{ color: 'green' }}>{t('save-success')}</p>}
      {error && (
        <p style={{ color: 'red' }}>
          {t('errors.save-failed')} {error.message || error.error} ({error.status || 500})
        </p>
      )}
    </div>
  );
}
